<template>
  <div class="bg-white rounded-2xl shadow-xl border border-gray-100 p-6">
    <h3 class="text-lg font-bold text-gray-900">{{ t("title") }}</h3>
    <p class="mt-0.5 mb-3 text-sm text-gray-500">{{ t("subtitle") }}</p>

    <div v-for="segment in segments" :key="segment.label" class="py-2.5 border-t border-gray-100">
      <div class="flex justify-between items-baseline text-sm mb-1.5">
        <span class="font-semibold text-gray-700">{{ segment.label }}</span>
        <strong class="text-base">{{ segment.count }}</strong>
      </div>
      <div class="h-2 rounded-full bg-gray-100 overflow-hidden">
        <div class="h-full rounded-full bg-primary" :style="{ width: barWidth(segment.count) }"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { useI18n } from "vue-i18n";
import { challengeDays } from "@/utils/challengePeriod";

export default {
  setup() {
    const { t } = useI18n();
    return { t };
  },

  props: {
    stores: {
      type: Array,
      default: () => [],
    },
    challenge: {
      type: Object,
      required: true,
    },
  },

  computed: {
    daysElapsed() {
      return Math.max(1, challengeDays(this.challenge).elapsed);
    },

    monthFactor() {
      return 30 / this.daysElapsed;
    },

    segments() {
      const bins = [
        { label: this.t("inactive"), min: -1, max: 0 },
        { label: this.t("below_5"), min: 0, max: 5 },
        { label: this.t("five_to_ten"), min: 5, max: 10 },
        { label: this.t("ten_to_thirty"), min: 10, max: 30 },
        { label: this.t("above_thirty"), min: 30, max: Infinity },
      ];

      return bins.map((bin) => {
        const count = this.stores.filter((s) => {
          const monthly = (s.salesCount || 0) * this.monthFactor;
          if (bin.max === 0) return s.salesCount === 0;
          return monthly > bin.min && monthly <= bin.max;
        }).length;
        return { ...bin, count };
      });
    },

    maxSegmentCount() {
      return Math.max(1, ...this.segments.map((s) => s.count));
    },
  },

  methods: {
    barWidth(count) {
      if (!count) return "0%";
      return Math.round((count / this.maxSegmentCount) * 100) + "%";
    },
  },
};
</script>

<i18n src="./TieredChallengeStoreDistribution.i18n.json"></i18n>
